import { Stadium } from 'elegislativa-frontend-ts-axios';

enum StadiumMaterialuEnum {
  FINALNE_PREDBEZNE_STANOVISKO = 'FINALNE_PREDBEZNE_STANOVISKO',
  MPK = 'MPK',
  PRED_VYHLASENIM_V_ZBIERKE = 'PRED_VYHLASENIM_V_ZBIERKE',
  PREDPRIPRAVNA_FAZA_UKONCENA = 'PREDPRIPRAVNA_FAZA_UKONCENA',
  PRIPRAVA_MATERIALU = 'PRIPRAVA_MATERIALU',
  PRIRADENIE_GESTORA = 'PRIRADENIE_GESTORA',
  PROCES_UKONCENY = 'PROCES_UKONCENY',
  ROKOVANIE_NRSR = 'ROKOVANIE_NRSR',
  ROKOVANIE_POV = 'ROKOVANIE_POV',
  ROKOVANIE_VLADA = 'ROKOVANIE_VLADA',
  SCHVALENIE_GESTORA = 'SCHVALENIE_GESTORA',
  SCHVALOVANIE_MINISTER = 'SCHVALOVANIE_MINISTER',
  SPRACOVANIE_PREDKLADATEL = 'SPRACOVANIE_PREDKLADATEL',
  VYHLASENE_V_ZBIERKE = 'VYHLASENE_V_ZBIERKE',
  VYHODNOTENIE_MPK = 'VYHODNOTENIE_MPK',
  VYHODNOTENIE_MPK_AKTY = 'VYHODNOTENIE_MPK_AKTY',
  VYJADRENIA = 'VYJADRENIA',
  ZAPIS_STANOVISKA = 'ZAPIS_STANOVISKA',
  ADMINISTRACIA_PROCESU = 'ADMINISTRACIA_PROCESU',
  APROXIMACIA_NARIADENIA = 'APROXIMACIA_NARIADENIA',
  APROXIMACIA_SMERNICE = 'APROXIMACIA_SMERNICE',
  ARCHIVOVANY_AEU = 'ARCHIVOVANY_AEU',
  CAKAJUCI_PUB_MOD = 'CAKAJUCI_PUB_MOD',
  DOPLNENIE_POZICIE = 'DOPLNENIE_POZICIE',
  FINALIZACIA_INSTRUKCIE = 'FINALIZACIA_INSTRUKCIE',
  FINALIZACIA_NOTIFIKACNYCH_FORMULAROV = 'FINALIZACIA_NOTIFIKACNYCH_FORMULAROV',
  FINALIZACIA_POZICIE = 'FINALIZACIA_POZICIE',
  KONTROLA_REDAKC_UPRAV = 'KONTROLA_REDAKC_UPRAV',
  MZV_EZ = 'MZV_EZ',
  NOTIFIKACNY_FORMULAR = 'NOTIFIKACNY_FORMULAR',
  OdoslaneRokovanieNrsr = 'ODOSLANE_ROKOVANIE_NRSR',
  ODOSLANE_ROKOVANIE_VLADY = 'ODOSLANE_ROKOVANIE_VLADY',
  ODOSLANE_ZZ = 'ODOSLANE_ZZ',
  PRED_PUBLIKOVANIM = 'PRED_PUBLIKOVANIM',
  PRIEBEZNE_ZAPRACOVANIE_PRIP = 'PRIEBEZNE_ZAPRACOVANIE_PRIP',
  PRIPOMIENKOVANIE_POZMEN_NAVRHOV_NRSR = 'PRIPOMIENKOVANIE_POZMEN_NAVRHOV_NRSR',
  PRIPRAVA_MATERIALU_ADMIN = 'PRIPRAVA_MATERIALU_ADMIN',
  PRIPRAVA_MATERIALU_PI = 'PRIPRAVA_MATERIALU_PI',
  PRIPRAVA_NELEG_MATERIALU = 'PRIPRAVA_NELEG_MATERIALU',
  PRIRADENIE_GESTORA_COREPER = 'PRIRADENIE_GESTORA_COREPER',
  PRIRADENIE_GESTORA_NARIADENIE = 'PRIRADENIE_GESTORA_NARIADENIE',
  PRIRADENIE_GESTORA_RADA_EU = 'PRIRADENIE_GESTORA_RADA_EU',
  PRIRADENIE_GESTORA_SMERNICA = 'PRIRADENIE_GESTORA_SMERNICA',
  PUBLIKACIA_RO = 'PUBLIKACIA_RO',
  ROKOVANIE_LRV = 'ROKOVANIE_LRV',
  ROKOVANIE_NRSR_NELEG_MAT = 'ROKOVANIE_NRSR_NELEG_MAT',
  ROKOVANIE_PRAC_KOMISII = 'ROKOVANIE_PRAC_KOMISII',
  ROKOVANIE_PREDKLADATEL = 'ROKOVANIE_PREDKLADATEL',
  ROKOVANIE_PREDKLADATEL_NELEG_MAT = 'ROKOVANIE_PREDKLADATEL_NELEG_MAT',
  ROKOVANIE_VLADA_NELEG_MAT = 'ROKOVANIE_VLADA_NELEG_MAT',
  SEFREDAKTOR_PRIDELOVANIE = 'SEFREDAKTOR_PRIDELOVANIE',
  SEFREDAKTOR_SCHVALENIE_PRED_PUBMOD = 'SEFREDAKTOR_SCHVALENIE_PRED_PUBMOD',
  SEFREDAKTOR_SCHVALENIE_PRED_PUBMOD_NELEG_MAT = 'SEFREDAKTOR_SCHVALENIE_PRED_PUBMOD_NELEG_MAT',
  SCHVALENE_NA_VLADE = 'SCHVALENE_NA_VLADE',
  SCHVALOVANIE_PREZIDENT = 'SCHVALOVANIE_PREZIDENT',
  SPRACOVANIE_REDAKTOR = 'SPRACOVANIE_REDAKTOR',
  SPRACOVANIE_REDAKTOR_NELEG_MAT = 'SPRACOVANIE_REDAKTOR_NELEG_MAT',
  SPRACOVANIE_SEFREDAKTOR = 'SPRACOVANIE_SEFREDAKTOR',
  SPRACOVANIE_SEFREDAKTOR_NELEG_MAT = 'SPRACOVANIE_SEFREDAKTOR_NELEG_MAT',
  VYHODNOTENIE_MPK_NELEG_MAT = 'VYHODNOTENIE_MPK_NELEG_MAT',
  VYHODNOTENIE_ROKOVANIA_NRSR = 'VYHODNOTENIE_ROKOVANIA_NRSR',
  VYHODNOTENIE_VYSLEDKU_ROKOVANIA = 'VYHODNOTENIE_VYSLEDKU_ROKOVANIA',
  VYHODNOTENIE_VYSLEDKU_ROKOVANIA_NELEG_MAT = 'VYHODNOTENIE_VYSLEDKU_ROKOVANIA_NELEG_MAT',
  VYTVORENIE_CIASTKOVEJ_INSTRUKCIE = 'VYTVORENIE_CIASTKOVEJ_INSTRUKCIE',
  VYTVORENIE_POZICIE = 'VYTVORENIE_POZICIE',
  ZAEVIDOVANIE_MATERIALU = 'ZAEVIDOVANIE_MATERIALU',
  ZAEVIDOVANIE_OPATRENIA = 'ZAEVIDOVANIE_OPATRENIA',
  ZAPIS_PREDBEZNEHO_STANOVISKA = 'ZAPIS_PREDBEZNEHO_STANOVISKA',
  ZAPIS_DOPLNENEHO_PREDBEZNEHO_STANOVISKA = 'ZAPIS_DOPLNENEHO_PREDBEZNEHO_STANOVISKA',
}

interface StadiumMaterialu {
  hodnota: StadiumMaterialuEnum,
  nazov: string,
}

function mapStadium(stadium: Stadium): StadiumMaterialu | undefined {
  if (!stadium) {
    return undefined;
  }
  return {
    hodnota: StadiumMaterialuEnum[stadium.hodnota],
    nazov: stadium.nazov,
  };
}

const stadiumMaterialuValues = new Map([
  [StadiumMaterialuEnum.FINALNE_PREDBEZNE_STANOVISKO, {
    nazov: 'Vytvorenie finálneho predbežného stanoviska',
  }],
  [StadiumMaterialuEnum.MPK, {
    nazov: 'Pripomienkové konanie',
  }],
  [StadiumMaterialuEnum.PRED_VYHLASENIM_V_ZBIERKE, {
    nazov: 'Pred vyhlásením v Zbierke zákonov SR',
  }],
  [StadiumMaterialuEnum.PREDPRIPRAVNA_FAZA_UKONCENA, {
    nazov: 'Predprípravná fáza ukončená',
  }],
  [StadiumMaterialuEnum.PRIPRAVA_MATERIALU, {
    nazov: 'Príprava materiálu',
  }],
  [StadiumMaterialuEnum.PRIRADENIE_GESTORA, {
    nazov: 'Priradenie gestora k vypracovaniu stanoviska',
  }],
  [StadiumMaterialuEnum.PROCES_UKONCENY, {
    nazov: 'Proces ukončený',
  }],
  [StadiumMaterialuEnum.ROKOVANIE_NRSR, {
    nazov: 'Rokovanie Národnej rady SR',
  }],
  [StadiumMaterialuEnum.ROKOVANIE_POV, {
    nazov: 'Rokovanie poradných orgánov vlády SR',
  }],
  [StadiumMaterialuEnum.ROKOVANIE_VLADA, {
    nazov: 'Rokovanie vlády SR',
  }],
  [StadiumMaterialuEnum.SCHVALENIE_GESTORA, {
    nazov: 'Schválenie gestora',
  }],
  [StadiumMaterialuEnum.SCHVALOVANIE_MINISTER, {
    nazov: 'Schvaľovanie zodpovedným predkladateľom',
  }],
  [StadiumMaterialuEnum.SPRACOVANIE_PREDKLADATEL, {
    nazov: 'Spracovanie predkladateľom',
  }],
  [StadiumMaterialuEnum.VYHLASENE_V_ZBIERKE, {
    nazov: 'Vyhlásené v Zbierke zákonov SR',
  }],
  [StadiumMaterialuEnum.VYHODNOTENIE_MPK, {
    nazov: 'Vyhodnotenie pripomienkového konania',
  }],
  [StadiumMaterialuEnum.VYHODNOTENIE_MPK_AKTY, {
    nazov: 'Vyhodnotenie pripomienkového konania (Akt EÚ)',
  }],
  [StadiumMaterialuEnum.VYJADRENIA, {
    nazov: 'Vyjadrenia k predbežnej informácii',
  }],
  [StadiumMaterialuEnum.ZAPIS_STANOVISKA, {
    nazov: 'Zápis stanoviska k návrhu aktu EÚ',
  }],
  [StadiumMaterialuEnum.ZAPIS_PREDBEZNEHO_STANOVISKA, {
    nazov: 'Zápis predbežného stanoviska k návrhu aktu EÚ',
  }],
  [StadiumMaterialuEnum.ZAPIS_DOPLNENEHO_PREDBEZNEHO_STANOVISKA, {
    nazov: 'Zápis doplneného predbežného stanoviska k návrhu aktu EÚ',
  }],
]);

const lpStadiumMaterialuValues = new Map([
  [StadiumMaterialuEnum.FINALNE_PREDBEZNE_STANOVISKO, {
    nazov: 'Vytvorenie finálneho predbežného stanoviska',
  }],
  [StadiumMaterialuEnum.MPK, {
    nazov: 'Pripomienkové konanie',
  }],
  [StadiumMaterialuEnum.PRED_VYHLASENIM_V_ZBIERKE, {
    nazov: 'Pred vyhlásením v Zbierke zákonov SR',
  }],
  [StadiumMaterialuEnum.PRIPRAVA_MATERIALU, {
    nazov: 'Príprava materiálu',
  }],
  [StadiumMaterialuEnum.PRIRADENIE_GESTORA, {
    nazov: 'Priradenie gestora k vypracovaniu stanoviska',
  }],
  [StadiumMaterialuEnum.PROCES_UKONCENY, {
    nazov: 'Proces ukončený',
  }],
  [StadiumMaterialuEnum.ROKOVANIE_NRSR, {
    nazov: 'Rokovanie Národnej rady SR',
  }],
  [StadiumMaterialuEnum.ROKOVANIE_POV, {
    nazov: 'Rokovanie poradných orgánov vlády SR',
  }],
  [StadiumMaterialuEnum.ROKOVANIE_VLADA, {
    nazov: 'Rokovanie vlády SR',
  }],
  [StadiumMaterialuEnum.SCHVALENIE_GESTORA, {
    nazov: 'Schválenie gestora',
  }],
  [StadiumMaterialuEnum.SCHVALOVANIE_MINISTER, {
    nazov: 'Schvaľovanie zodpovedným predkladateľom',
  }],
  [StadiumMaterialuEnum.SPRACOVANIE_PREDKLADATEL, {
    nazov: 'Spracovanie predkladateľom',
  }],
  [StadiumMaterialuEnum.VYHLASENE_V_ZBIERKE, {
    nazov: 'Vyhlásené v Zbierke zákonov SR',
  }],
  [StadiumMaterialuEnum.VYHODNOTENIE_MPK, {
    nazov: 'Vyhodnotenie pripomienkového konania',
  }],
  [StadiumMaterialuEnum.VYHODNOTENIE_MPK_AKTY, {
    nazov: 'Vyhodnotenie pripomienkového konania (Akt EÚ)',
  }],
  [StadiumMaterialuEnum.ZAPIS_STANOVISKA, {
    nazov: 'Zápis stanoviska k návrhu aktu EÚ',
  }],
  [StadiumMaterialuEnum.ZAPIS_PREDBEZNEHO_STANOVISKA, {
    nazov: 'Zápis predbežného stanoviska k návrhu aktu EÚ',
  }],
  [StadiumMaterialuEnum.ZAPIS_DOPLNENEHO_PREDBEZNEHO_STANOVISKA, {
    nazov: 'Zápis doplneného predbežného stanoviska k návrhu aktu EÚ',
  }],
]);

const piStadiumMaterialuValues = new Map([
  [StadiumMaterialuEnum.PREDPRIPRAVNA_FAZA_UKONCENA, {
    nazov: 'Predprípravná fáza ukončená',
  }],
  [StadiumMaterialuEnum.PRIPRAVA_MATERIALU, {
    nazov: 'Príprava materiálu',
  }],
  [StadiumMaterialuEnum.VYJADRENIA, {
    nazov: 'Vyjadrenia k predbežnej informácii',
  }],
  [StadiumMaterialuEnum.PROCES_UKONCENY, {
    nazov: 'Proces ukončený',
  }],
]);

function getStadiumNazov(stadium: StadiumMaterialuEnum): string {
  if (!stadium) {
    return '';
  }
  return stadiumMaterialuValues.get(stadium).nazov;
}

export {
  StadiumMaterialu, StadiumMaterialuEnum, mapStadium,
  stadiumMaterialuValues, lpStadiumMaterialuValues, piStadiumMaterialuValues, getStadiumNazov,
};
